<template>
  <el-dialog
    :visible.sync="visible"
    title="投标保函详情"
    :close-on-click-modal="false"
    class="dialog"
    width="500px"
  >
    <el-form label-suffix="：">
      <el-form-item label="保函状态">
        <span>{{ letterStatus }}</span>
      </el-form-item>
      <el-form-item v-if="this.letterOrder.letterUrl" label="保函文件">
        <el-button type="text" @click="openLetterFileUrl">
          点击下载保函文件
        </el-button>
      </el-form-item>
      <el-form-item label="申请理赔">
        <el-button type="text" @click="applyClaim">点击申请理赔</el-button>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="closeDialog">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { getOnlineLetterApplicationNewestApi } from '@/api/supplier/guaranteee'
import {
  onlineLetterApprovalStatusDict,
  onlineLetterOrderStatusDict
} from '@/dictionary/guarantee'

/**
 * 在线保函弹窗
 */
export default {
  name: 'OnlineLetterInfoDialog',

  data() {
    return {
      visible: false,

      // 保函信息
      letterInfo: {}
    }
  },

  computed: {
    letterOrder() {
      return this.letterInfo.orderInfo || {}
    },

    letterStatus() {
      // 保函订单状态为退回中或退保成功时显示，其余均显示保函的审批状态
      const { SURRENDERING, SUCCESS } = onlineLetterOrderStatusDict
      const letterOrderStatusList = [SURRENDERING, SUCCESS]
      if (letterOrderStatusList.includes(this.letterOrder.orderStatus)) {
        return onlineLetterOrderStatusDict.translate(
          this.letterOrder.orderStatus
        )?.label
      }
      return onlineLetterApprovalStatusDict.translate(
        this.letterInfo.approvalStatus
      )?.label
    }
  },

  methods: {
    openDialog(code) {
      this.visible = true
      this.getLetterInfo(code)
    },

    closeDialog() {
      this.visible = false
      this.letterInfo = {}
    },

    /**
     * 获取保函信息
     */
    getLetterInfo(code) {
      getOnlineLetterApplicationNewestApi(code)
        .then(res => {
          this.letterInfo = res.data || {}
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 打开保函文件地址
     */
    openLetterFileUrl() {
      window.open(this.letterOrder.letterUrl, '_blank')
    },

    /**
     * 点击申请理赔
     */
    applyClaim() {
      this.$systemConfirm('请联系“王广英 18720065992”进行处理', '申请理赔')
    }
  }
}
</script>

<style scoped lang="scss"></style>
